/**
 * @Author ZhangYing
 * @Date 2022-04-24 14:55:39
 * @LastEditors ZhangYing
 * @LastEditTime 2025-11-12 11:10:18
 * @Description
 * @FilePath /BM-Main/src/router/order-new.js
 * @props
 */
/**
 * 路由暂时保留，可能有遗漏未修改到的跳转寄卖页面的地方，通过sentry收集一段时间，定位修改
 */
import { locationReplace } from '@/utils/helper'

export default {
  // 寄卖相关业务路由
  path: '/order-new',
  children: [
    {
      path: 'drw-orderdetail',
      name: 'drw-orderdetail',
      meta: { title: '订单详情' },
      beforeEnter: () => {
        locationReplace('https://m.zhuanzhuan.com/u/consign_main/order/drw-orderdetail')
      }
    }

  ]
}
